export enum CLIENTS {
  GOVERNMENT = 'Government',
  CONSUMERS = 'Consumers',
  BUSINESSES = 'Businesses'
}
